module.exports = __webpack_public_path__ + "img/why-t.14a55ea4.jpg";